import React from "react";
import { MdPhoneForwarded, MdPhoneInTalk, MdPhoneMissed } from "react-icons/md";

const Incoming = ({ connection,setIncomingCallStatus,setConnIncomming }) => {
  const acceptConnection = () => {
    connection.accept();
    setIncomingCallStatus("Llamada en curso")
  };
  const rejectConnection = () => {
    connection.reject();
    setIncomingCallStatus("")
    if(connection){
      setConnIncomming(null)
    }

  };
  return (
    <>
      <div className=" max-w-sm w-full mx-auto  mt-20 px-4 py-10 rounded-lg bg-gray-50 shadow-lg grid grid-cols-2 gap-2 ">
        <div className=" col-span-2 pb-4">
          <p className=" text-center font-bold text-gray-700">Llamada entrante ...</p>

        </div>
        <button type="button" onClick={acceptConnection} className="flex justify-center gap-2 items-center p-3 hover:animate-none hover:bg-green-800 hover:bg-opacity-10 hover:scale-105 hover:transition duration-300  animate-pulse bg-green-700 bg-opacity-10 text-green-600 font-bold rounded-md ">
          <span className=" z-[9995]">Contestar</span>
          <div className="    bg-white p-3 rounded-full">
            <MdPhoneInTalk className=" animate" />
          </div>
        </button>

        <button type="button" onClick={rejectConnection} className="flex justify-center gap-2 items-center p-3 h hover:bg-red-800 hover:bg-opacity-10 hover:scale-105 hover:transition duration-300   bg-red-700 bg-opacity-10 text-red-600 font-bold rounded-md ">
          <span className=" z-[9995]">Rechazar</span>
          <div className="    bg-white p-3 rounded-full">
            <MdPhoneMissed className=" animate" />
          </div>
        </button>
      </div>
    </>
  );
};

export default Incoming;
